import React from "react";
import { Typography, CircularProgress, alpha } from "@mui/material";
import {
  GlassScrollArea,
  GlassAlert,
  EmptyStateContainer,
  LoadingContainer,
  LoadMoreButton,
} from "../layouts/GlassTileLayout";
import ActivityItem from "./ActivityItem";

const ActivityFeedContent = ({
  activities = [],
  loading,
  error,
  hasMore,
  onLoadMore,
}) => {
  if (error) {
    return <GlassAlert severity="error">{error}</GlassAlert>;
  }

  return (
    <GlassScrollArea>
      {loading && activities.length === 0 ? (
        <LoadingContainer>
          <CircularProgress />
        </LoadingContainer>
      ) : (
        <>
          {activities.length > 0
            ? activities.map((activity, index) => (
                <React.Fragment key={`${activity._id}-${index}`}>
                  <ActivityItem activity={activity} />
                </React.Fragment>
              ))
            : !loading && (
                <EmptyStateContainer>
                  <Typography
                    variant="h6"
                    sx={{
                      mb: 1,
                      fontWeight: 600,
                      color: (theme) => alpha(theme.palette.text.primary, 0.8),
                    }}
                  >
                    No Activities Yet
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: (theme) =>
                        alpha(theme.palette.text.secondary, 0.9),
                      position: "relative",
                      zIndex: 1,
                    }}
                  >
                    Start diving to see your feed come to life!
                  </Typography>
                </EmptyStateContainer>
              )}

          {hasMore && (
            <LoadMoreButton
              onClick={onLoadMore}
              disabled={loading}
              variant="outlined"
              fullWidth
            >
              {loading ? <CircularProgress size={24} /> : "Load More"}
            </LoadMoreButton>
          )}
        </>
      )}
    </GlassScrollArea>
  );
};

export default ActivityFeedContent;
